module.exports = __webpack_public_path__ + "static/img/music_empty_normal.cc856a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music_empty_normal.png
// module id = FF/v
// module chunks = 1